import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';
import { FormVisualizer } from './Form/formVisualizer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ForbiddenDateValidatorDirective } from './Form/ForbiddenDateValidatorDirective';
import { ConsentValidator } from "./Form/ConsentValidator";
import { FileTypeValidatation } from "./Form/FileValidatation";
import { InactiveComponent } from './inactive/inactive.component';
import { ClosedComponent } from './closed/closed.component';
import { FileRequiredValidation } from "./Form/FileRequiredValidation";
import { FileValueAccessor } from './Form/FileValueAccessor';
import { Changelog } from './changelog/changelog.component';
import { ReapplyComponent } from './reapply/reapply.component';
import { ApplicationInsightsService } from './services/application-insights.service';
import { ApplicationInsightsErrorHandler } from './services/application-insight-error-handler';
import localePL from '@angular/common/locales/pl'
import { registerLocaleData } from '../../node_modules/@angular/common';

registerLocaleData(localePL);

const appRoutes: Routes = [
  { path: 'rekrutacja/:guid', component: FormVisualizer },
  { path: 'dodaj-zgode/:guid', component: ReapplyComponent },
  { path: 'rekrutacja-nieaktywna', component: InactiveComponent },
  { path: 'rekrutacja-zamknięta', component: ClosedComponent },
  { path: 'changelog', component: Changelog }
];

@NgModule({
  declarations: [
    AppComponent,
    FormVisualizer,
    AppComponent,
    ForbiddenDateValidatorDirective,
    ConsentValidator,
    InactiveComponent,
    FileTypeValidatation,
    FileRequiredValidation,
    ClosedComponent,
    FileValueAccessor,
    Changelog,
    ReapplyComponent
  ],

  imports: [
    BrowserModule,
    HttpClientModule,
    NgbModule.forRoot(),
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    ),
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [RouterModule],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ApplicationInsightsErrorHandler
    },
    ApplicationInsightsService],
  bootstrap: [AppComponent]
})
export class AppModule { }
